import { createContext, useContext } from 'react';
export const TourTrackingContext = /*#__PURE__*/createContext(undefined);
export const useTourTrackingContext = () => {
  return useContext(TourTrackingContext);
};
export const useTourTrackingMethod = name => {
  const {
    usageTracker
  } = useContext(TourTrackingContext) || {};

  if (usageTracker && usageTracker[name]) {
    return usageTracker[name];
  }

  return undefined;
};